import { data, event } from 'jquery';
import '../internals/global';
import '../internals/acf/kg-numeric-slider';

/**
 * Function utilisée sur le formulaire "Postuler"
 */

(function (w) {
    w.Kinougarde = Object.assign({}, w.Kinougarde, { Tarif: {} });

    if (document.getElementById("section-tarif") != null) {
        // Masque le banner sticky pour ne l'afficher que sur la dernière étape
        sessionStorage.setItem("sticky-banner-closed", true);
    }

    /**
     * Initialisation du formulaire
     */
    w.Kinougarde.Tarif.initFormulaireTarif = function () {

        //Valeur par défaut du formulaire
        Kinougarde.Tarif.dataFormulaire = Kinougarde.GetStorage("form-simulation-budgetaire") || {};

        var rechercheViaUnFlexibleContent = Kinougarde.RechercheNounou.getRechercheNounou();
        if (rechercheViaUnFlexibleContent !== null) {
            w.Kinougarde.Tarif.dataFormulaire = Object.assign(Kinougarde.Tarif.dataFormulaire, rechercheViaUnFlexibleContent);
            Kinougarde.formulaireAcf.InitFormulaire({ defaultValue: Kinougarde.Tarif.dataFormulaire, defaultStep: 1 }); // 1= Index de l'étape par défaut
            Kinougarde.Tarif.toogleEstDesservie(Kinougarde.Tarif.dataFormulaire.desservie);

        } else {
            Kinougarde.formulaireAcf.InitFormulaire({ defaultValue: Kinougarde.Tarif.dataFormulaire });
        }

        //Notifie un changement éventuel sur le slider (changement via les valeur par défaut)
        $("#nombre_heures").trigger("change");

        // Retire le cadre sur la dernière étape
        jQuery("#step_tarif,#step_carte").closest(".owl-item").addClass("sans-cadre");

        // Capte le résultat de l'action ajax est_desservie sur l'étape "Adresse"        
        jQuery("#step_adresse").on("form-step-next-changed", function (e, reponse, data) {
            Kinougarde.Tarif.toogleEstDesservie(reponse.data);
        });


        jQuery("#step_adresse").on("ajax-action-error", function (e, data) {
            if (data.data.error_code == "NON_DESSERVIE") {

                dataLayer.push({ 'event': 'COMMUNE_NON_DESSERVIE', ...w.Kinougarde.GetGlobalUtmFields() })
            }
        });


        // Capte le click sur "Recevoir ma simulation budgetaire" ou "Voir les nounous" ( étape "Coordonnées" )
        // Avant l'appel de l'action Ajax afin de modifier les données envoyées
        jQuery("#step_coordonnees").on("form-step-next-change", function (event, options) {
            // Version "trouver nounou" ou "calculer budget"
            options.data = { "Version": $("#section-tarif").data("version"), "url": document.location.href };
            // Ajoute l'id de la transaction précédente
            if (Kinougarde.GetStorage("form-simulation-budgetaire-ti") != null) {
                options.data = Object.assign(options.data, { "ti": Kinougarde.GetStorage("form-simulation-budgetaire-ti") });
            }
            return options;
        })

        // Capte le résultat après un click sur "Recevoir ma simulation budgetaire" ou "Voir les nounous" ( étape "Coordonnées" )        
        jQuery("#step_coordonnees").on("form-step-next-changed", function (e, reponse, data) {
            try {
                var html = reponse.data.HtmlTarif;
                Kinougarde.Tarif.dataFormulaire = data;

                //Affichage de la  simulation budgetaire
                w.Kinougarde.Tarif.dataDevis = reponse.data;
                w.Kinougarde.Tarif.NbHeureAjustee = reponse.data.NombreHeuresGardeHebdomadaires

                jQuery("#resultat_devis").html(html);
                jQuery(".header-form h1").addClass("hidden");
                // Affiche le lien carte
                if (reponse.data.IntervenantDisponibles != null && reponse.data.IntervenantDisponibles.NbIntervenants > 0) {
                    jQuery("#resultat_nounou").html("Il y a " + reponse.data.IntervenantDisponibles.NbIntervenants + " nounous près de chez moi !<div><a href=\"#\" id=\"voir_la_carte\">Voir la carte</a></div>");
                    //Click sur "Voir la carte"      
                    jQuery("#resultat_nounou").on('click', function (ev) {
                        ev.preventDefault();
                        jQuery("#carte").scrollToElement();
                    });
                }

                //Ouvre l'acordéon "Ajuster mon budget" uniquement pour la version "Simulation budgétaire"
                if (data.Version == "CalculerVotreBudget") {
                    jQuery("#resultat_devis .ajuster-tarif").addClass("toggled");
                }

                //Initialise les composants html de resultat devis
                var slider = jQuery("#resultat_devis [data-acf-type=kg-numeric-slider]");
                w.Kinougarde.AcfKgNumericSlider.init(slider);
                Kinougarde.Tarif.RefreshCalculDevis(reponse.data.NombreHeuresGardeHebdomadaires, false, false)

                // Capte un changement sur le slider
                slider.on('acf-field-type-numeric-slider-change', function (e, value) {
                    w.Kinougarde.Tarif.NbHeureAjustee = value;
                    jQuery("#button_email svg").removeClass("disabled");
                    jQuery("div.ajax-error").remove();
                    Kinougarde.Tarif.RefreshCalculDevis(value, jQuery("#famille_monoparentale").prop('checked'), jQuery("#enfant_handicap").prop('checked'));
                })

                // Clic sur une des check box
                jQuery("#resultat_devis [type=checkbox]").on('click', function (e) {
                    jQuery("#button_email svg").removeClass("disabled");
                    jQuery("div.ajax-error").remove();
                    Kinougarde.Tarif.RefreshCalculDevis(w.Kinougarde.Tarif.NbHeureAjustee, jQuery("#famille_monoparentale").prop('checked'), jQuery("#enfant_handicap").prop('checked'));
                })

                // Clic sur le bouton "Recevoir devis"
                jQuery("#button_email").on('click', function (e) {
                    Kinougarde.Tarif.EnvoiDevisSupplementaire();
                });

                if (reponse.data.Agence.NouvelleAgence == false) {
                    //Affichage de la  carte des nounous
                    Kinougarde.CarteNounou.ChargerCarte($("#carte").data("zoom"), $("#adresse_lat").val(), $("#adresse_lng").val(), $("#carte").data("densite"));
                } else {
                    // Supprime la carte pour les nouvelles agences
                    $("#carte").remove();
                    $("#voir_la_carte").remove();
                }

                // Mise à jour des infos de l'agence                
                w.Kinougarde.UpdateAgence(reponse.data.Agence);
                sessionStorage.removeItem("sticky-banner-closed");
                w.Kinougarde.ShowBoutonSticky();


                // Mémorise les données du formulaire pour une prochaine utilisation
                // se base sur le consentement de l'utilisateur
                Kinougarde.SetStorage("form-simulation-budgetaire", data);
                //Mémorise l'id de la transaction pour réutilisation 
                Kinougarde.SetStorage("form-simulation-budgetaire-ti", reponse.data.Id);

                // Notification Tagmanager (Attention cette ligne doit être faite en dernier)
                Kinougarde.TagManagerTunnel(data.Version == "TrouverVotreNounou" ? "TrouverNounou/step-6" : "SimulationBudgetaire/step-6",
                    { 'DevisCible': reponse.data.DevisCible, 'ValeurDevis': reponse.data.IaEstimationNombreHeuresCollectees * reponse.data.IaEstimationTauxConversion });

            }
            catch (e) {
            }
        });


        // Gestion de l'étape Date de naissance selon clic "Moins de 1 an" ou pas
        jQuery("#step_age_enfant_le_plus_jeune").on("form-step-next-change", function (event, options) {
            if (jQuery("#age_enfant1").prop("checked") || jQuery("#age_enfant2").prop("checked")) {
                //Passe à l'étape coordonneés

                // Désactive la validation de la date de naissance
                jQuery("#date_naissance").removeAttr("data-parsley-required");
                jQuery("#date_naissance").removeAttr("required");
                var indexEtapeCoordonne = jQuery(".acf-steps .step-form").index(jQuery("#step_coordonnees"));
                options = { 'stepIndex': indexEtapeCoordonne };
            }
            else if (jQuery("#age_enfant19").prop("checked")) {
                // Passe à l'étape "Mode de garde alternatif"
                // Désactive la validation de la date de naissance
                jQuery("#date_naissance").removeAttr("data-parsley-required");
                jQuery("#date_naissance").removeAttr("required");
                var indexEtapeModeDeGarde = jQuery(".acf-steps .step-form").index(jQuery("#step_mode_de_garde"));
                options = { 'stepIndex': indexEtapeModeDeGarde };
            }
            else {
                // Passe à l'étape "Date de naissance de l'enfant le plus jeune"
                // Active la validation de la date de naissance
                jQuery("#date_naissance").attr("data-parsley-required", "true");
            }
            return options;
        });

        // Capte le click Retour sur l'étape Coordonnée
        jQuery("#step_coordonnees").on("form-step-prev-changed", function () {
            if (jQuery("#age_enfant1").prop("checked") || jQuery("#age_enfant2").prop("checked")) {
                //Retour à l'étape age de l'enfant
                var indexEtapeAgeEnfant = jQuery(".acf-steps .step-form").index(jQuery("#step_age_enfant_le_plus_jeune"));
                Kinougarde.formulaireAcf.NextStep({ 'stepIndex': indexEtapeAgeEnfant });
            }
            else if (jQuery("#age_enfant19").prop("checked") || jQuery("#age_enfant18").prop("checked")) {
                //Retour à Mode de garde
                var indexEtapeModeDeGarde = jQuery(".acf-steps .step-form").index(jQuery("#step_mode_de_garde"));
                Kinougarde.formulaireAcf.NextStep({ 'stepIndex': indexEtapeModeDeGarde });
            }
        });
        // Capte le click Retour sur l'étape Mode de garde
        jQuery("#step_mode_de_garde").on("form-step-prev-changed", function () {
            if (jQuery("#age_enfant19").prop("checked")) {
                //Retour à l'étape age de l'enfant
                var indexEtapeAgeEnfant = jQuery(".acf-steps .step-form").index(jQuery("#step_age_enfant_le_plus_jeune"));
                Kinougarde.formulaireAcf.NextStep({ 'stepIndex': indexEtapeAgeEnfant });
            }
        });


    };

    /**
     * Envoi d'un e-mail supplémentaire de devis
     */
    w.Kinougarde.Tarif.EnvoiDevisSupplementaire = function () {
        var $step = Kinougarde.formulaireAcf.CurrentStep();
        var svg = jQuery("#button_email svg");

        if (!svg.hasClass("email-loading") && !svg.hasClass("disabled") && !svg.hasClass("ok")) {
            svg.addClass("email-loading");
            data = Object.assign({ 'action': 'ajax_simulation_budgetaire' }, Kinougarde.Tarif.dataFormulaire,
                {
                    'nombre_heures': Kinougarde.Tarif.NbHeureAjustee,
                    'famille_monoparentale': jQuery("#famille_monoparentale").prop('checked') || false,
                    'enfant_handicap': jQuery("#enfant_handicap").prop('checked') || false,
                    'ti': Kinougarde.GetStorage("form-simulation-budgetaire-ti")
                }
            );

            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: ajax_kinougarde_object.ajaxurl,
                data: data,
                success: function (reponse) {


                    svg.removeClass("email-loading");
                    svg.addClass("ok");
                    setTimeout(function () {
                        svg.removeClass("ok");
                        svg.addClass("disabled");
                    }, 2000);
                    if (reponse.success === true) {
                        // Supprime les erreurs précédentes
                        $("div.ajax-error").remove();

                    } else if (reponse.success === false) {
                        // Code 200 , mais erreur métier, on affiche le message                            
                        if (typeof (reponse.data.error_msg) !== 'undefined') {
                            Kinougarde.formulaireAcf.AfficherErrorAjax(reponse.data.error_msg, jQuery("#resultat_devis .row.error"));
                        } else {
                            Kinougarde.formulaireAcf.AfficherErrorAjax("Désolé, une erreur a été détectée, veuillez réessayer plus tard", jQuery("#resultat_devis .row.error"));
                        }
                        // Propage un évènement ajax-action-error 
                        $step.trigger("ajax-action-error", [reponse]);
                    }

                },
                error: function (reponse) {
                    // Affichage d'un message d'erreur                             
                    svg.removeClass("email-loading");
                    svg.addClass("disabled");
                    if (reponse.responseJSON && reponse.responseJSON.data && reponse.responseJSON.data.error_msg) {
                        Kinougarde.formulaireAcf.AfficherErrorAjax(reponse.responseJSON.data.error_msg, jQuery("#resultat_devis .row.error"));
                    } else {
                        Kinougarde.formulaireAcf.AfficherErrorAjax("Désolé, une erreur a été détectée, veuillez réessayer plus tard", jQuery("#resultat_devis .row.error"));
                    }
                    // Propage un évènement ajax-action-error 
                    $step.trigger("ajax-action-error", [reponse]);
                }
            });
        }
    }

    /**
     * 
     * @param {*} codeNatureOffreGe 
     */
    w.Kinougarde.Tarif.toogleEstDesservie = function (data) {
        try {
            // Affiche le message X nounou à moins de 500 mètres
            var html = '<div class="results"><span class="text-bold">' + data.Ville + '</span><br><span class="text-bold">' + data.NbIntervenants + ' nounous près de chez vous !</span></div>';
            jQuery("#step_coordonnees .results").remove();
            jQuery("#step_coordonnees .form-step h2").before(html);

            // Affiche ou masque "Moins de 1 ans" et "1 à 3 ans" si non désservie pour les moins de 3 ans
            if (data.CodeNatureOffreGe === 2) {
                // Zone plus de 3 ans uniquement
                $("#age_enfant18").closest(".tap-bloc").addClass("hidden");
                $("#age_enfant19").closest(".tap-bloc").addClass("hidden");
            } else {
                // Zone tous les ages
                $("#age_enfant18").closest(".tap-bloc").removeClass("hidden");
                $("#age_enfant19").closest(".tap-bloc").removeClass("hidden");
            }
        }
        catch (e) {

        }

    }

    /**
     * Retourne l'ojet js à mapper dans le dom 
     */
    w.Kinougarde.Tarif.RefreshCalculDevis = function (nbHeureDeGarde, monoparental, handicap) {
        try {
            var dataDevis = w.Kinougarde.Tarif.dataDevis;
            var nbHeuresParMois = this.CalculNombreHeureParMois(dataDevis, nbHeureDeGarde);
            var tarifHoraire = this.CalculTarifHoraire(dataDevis, nbHeureDeGarde);
            var montantPaje = this.CalculMontantPaje(dataDevis, nbHeureDeGarde, handicap, monoparental);
            var coutBrutParMois = this.CalculCoutBrutParMois(dataDevis, nbHeureDeGarde);
            var montantAvantCreditImpot = (coutBrutParMois - montantPaje).toFixed(2);
            var creditImpot = (montantAvantCreditImpot * dataDevis.EstimationBudgetaireHtml.TauxReductionImpot).toFixed(2);
            var coutNetParMois = (montantAvantCreditImpot - creditImpot).toFixed(2);
            var coutNetParHeure = (coutNetParMois / nbHeuresParMois).toFixed(2);

            var mapObject = {
                CoutBrutParMois: coutBrutParMois.toString().replace(".", ","),
                CoutBrutParMoisHT: (coutBrutParMois / (1 + dataDevis.EstimationBudgetaireHtml.TauxTva)).toFixed(2).replace(".", ","),
                NbHeuresHebdo: nbHeureDeGarde,
                NbHeuresParMois: nbHeuresParMois.toString().replace(".", ","),
                TarifHoraire: tarifHoraire.toFixed(2).replace(".", ","),
                TarifHoraireHT: (tarifHoraire / (1 + dataDevis.EstimationBudgetaireHtml.TauxTva)).toFixed(2).replace(".", ","),
                MontantPaje: montantPaje.toString().replace(".", ","),
                MontantAvantCreditImpot: montantAvantCreditImpot.toString().replace(".", ","),
                CreditImpot: creditImpot.toString().replace(".", ","),
                CoutNetParMois: coutNetParMois.toString().replace(".", ","),
                CoutNetParHeure: coutNetParHeure.toString().replace(".", ",")
            }

            $("#resultat_devis").mapObject(mapObject, "tarif");
        }
        catch (ex) {
            console.debug("Erreur dans le calcul des tarifs ...")
        }

    }


    /**
    * Calcul nb heure dans le mois
    */
    w.Kinougarde.Tarif.CalculNombreHeureParMois = function (datadevis, nbHeureDeGarde) {
        try {
            return Math.max(Math.round(nbHeureDeGarde * datadevis.EstimationBudgetaireHtml.NbSemaineParMois), datadevis.EstimationBudgetaireHtml.NbHeuresGardeParMoisMin);
        }
        catch (ex) {
            console.debug("Erreur de calcul dans CalculNombreHeureParMois");
        }
    }

    /**
     * Calcul du tarif horaire
     * @param {*} datadevis 
     * @param {*} nbHeureDeGarde 
     * @param {*} handicap 
     * @param {*} monoparental 
     */
    w.Kinougarde.Tarif.CalculTarifHoraire = function (datadevis, nbHeureDeGarde) {
        try {
            return datadevis.EstimationBudgetaireHtml.TarifHoraireBrut - this.CalculReductionTarifHoraire(datadevis, nbHeureDeGarde);
        }
        catch (ex) {
            console.debug("Erreur de calcul dans CalculTarifHoraire");

        }
    }

    /**
     * Calcul de la reduction selon le volume horaire
     * @param {*} datadevis 
     * @param {*} nbHeureDeGarde 
     */
    w.Kinougarde.Tarif.CalculReductionTarifHoraire = function (datadevis, nbHeureDeGarde) {
        try {
            // Retrouve la reduction a appliquer            
            var reductions = datadevis.EstimationBudgetaireHtml.ReductionsHoraires;
            var montantreduction = 0;
            reductions.forEach(reduc => {
                if (nbHeureDeGarde >= reduc.QuantiteHebdoMinAchetee && reduc.MontantReductionEuro > montantreduction) {
                    montantreduction = reduc.MontantReductionEuro;
                }
            });
            return montantreduction;
        }
        catch (ex) {
            console.debug("Erreur de calcul dans CalculReductionTarifHoraire");
        }
    }


    /**
     * Calcul du cout Brut par mois
    */
    w.Kinougarde.Tarif.CalculCoutBrutParMois = function (datadevis, nbHeureDeGarde) {
        try {
            return (this.CalculNombreHeureParMois(datadevis, nbHeureDeGarde) * this.CalculTarifHoraire(datadevis, nbHeureDeGarde)).toFixed(2);
        }
        catch (ex) {
            console.debug("Erreur de calcul dans CalculCoutBrutParMois");
        }
    }

    /**
     * Calcul du montant de la paje (Limité à 85% du montant total)      
    */
    w.Kinougarde.Tarif.CalculMontantPaje = function (datadevis, nbHeureDeGarde, handicap, monoparental) {
        try {
            var montantbrutEuros = this.CalculCoutBrutParMois(datadevis, nbHeureDeGarde);

            var montantBrutpaje = datadevis.EstimationBudgetaireHtml.MontantAllocationPaje;
            if (handicap || monoparental) {
                // Suplement de 30%
                montantBrutpaje = montantBrutpaje * (1 + datadevis.EstimationBudgetaireHtml.TauxSupplementPaje / 100);
            }
            return (Math.min(montantBrutpaje, montantbrutEuros * datadevis.EstimationBudgetaireHtml.TauxMaxPriseEnChargePaje / 100)).toFixed(2);
        }
        catch (ex) {
            console.debug("Erreur de calcul dans CalculMontantPaje");
        }
    }


})(window);

jQuery(function () {
    try {
        //Formulaire de "Simulation budgétaire" ou "trouver nounou"
        if (jQuery("#section-tarif").length > 0) {
            Kinougarde.Tarif.initFormulaireTarif();

        };
    }
    catch (ex) {
        console.error(ex);
    }
});